export class Actor {
	public id = 0;
	public name = "";
	public imageURL = "";
	public leftImageURL = "";
	public rightImageURL = "";
	public aliases = "";
	public useThe = false;
}
